/* 詳細画面 申込(近代資金メイン) */
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { useCallApi } from '../../hooks/CallApi';
import useFetchReceptionData from '../../hooks/FetchReceptionData';
import ModernisationFundingContractContentConfirm from './ModernisationFundingContractContentConfirm';
import ModernisationFundingConfirmationResults from './ModernisationFundingConfirmationResults';
import ContractApplicationConfirmation from './ContractApplicationConfirmation';
import ContractApplicationFinish from './ContractApplicationFinish';
import ContractApplicationDeclined from './ContractApplicationDeclined';
import ScrollTop from '../../ScrollTop';
import DeclineLoanApplication from './DeclineLoanApplication';
import ModernisationFundingCaseDetails from './ModernisationFundingCaseDetails';
import {
  KWANKGM04080A01,
  KWANKGM04080A02,
  KWANKGM04330A01,
  KWANKGM04330A02,
  KDANKGM05010A01,
  KDANKGM05010A02,
} from '../../const/api_modules';
import { FixedValuesContext } from '../../context/FixedValues';
import useLazyLoad from '../../hooks/LazyLoad';
import { hasErrorMessage } from '../../Common';

const AppModernizationFundsMain: React.FC = () => {
  // ローディング画面制御
  const [is_loading, setIsLoading] = useState(false);
  const {
    // ヘッダ
    label,
    guide_text,
    step_navigation,
    display_reception_cd,
    display_status,
    // 詳細画面情報
    parent_shelfs,
    child_shelfs,
    contents,
    is_bank_exists,
    is_ja_exists,
    // 固定パラメータ
    status_name,
    status_code,
    loan_type,
    reception_id,
    reception_cd,
    reception_sub_cd,
    ident_lv1_cd,
    ident_lv2_cd,
    ident_lv3_cd,
    ja_name,
    opened_mypage,
    is_staff,
    applied,
    is_change,
    has_debtor,
    is_disagree,
    change_request_message,
    guarantors_num,
    sign_info,
    agreement_info,
    is_signed,
    agreements,
    guarantor_info,
    review_approval_status,
    review_approval_status_name,
    review_message,
    contract_info,
    is_checked_contract_document,
    has_loan_approval,
    mp_flg,
    ma_flg,
    is_implement_online_identification,
    online_identification_modal_open,
    // ファイルアップローダ
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    // お客様へのお知らせ
    info_notice_contract_confirm,
    // 辞退ボタンの活性フラグ
    is_active_decline_btn,
    is_signer,
    // ディスパッチ
    setParentShelfs,
    setChildShelfs,
    setContents,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    setDisplayStatus,
    // 関数
    moveStepNav,
    setLabel,
    setStepNavigation,
    setIsImplementOnlineIdentification,
    setOnlineIdentificationModalOpen,
  } = useFetchReceptionData(setIsLoading);

  // API呼び出し処理
  const { setShowErrorNav, show_error_nav, requestModule, api_response_detail } = useCallApi(
    child_shelfs,
    contents,
    setContents,
    setChildShelfs,
    reception_id,
    reception_cd,
    status_code,
    is_staff,
    setIsLoading,
    guarantor_info,
    setOnlineIdentificationModalOpen
  );

  // 書類画像の遅延ロード
  useLazyLoad(
    shelf_info_a,
    shelf_info_b,
    shelf_info_c,
    shelf_info_d,
    shelf_info_e,
    shelf_info_f,
    shelf_info_g,
    shelf_info_h,
    shelf_info_i,
    shelf_info_j,
    shelf_info_k,
    shelf_info_aa,
    shelf_info_ab,
    shelf_info_ac,
    shelf_info_ad,
    shelf_info_ae,
    shelf_info_af,
    shelf_info_ag,
    shelf_info_ah,
    shelf_info_ai,
    shelf_info_aj,
    shelf_info_ak,
    shelf_info_al,
    shelf_info_am,
    shelf_info_an,
    shelf_info_ao,
    shelf_info_ap,
    shelf_info_aq,
    shelf_info_ar,
    shelf_info_as,
    shelf_info_at,
    shelf_info_au,
    shelf_info_av,
    shelf_info_aw,
    shelf_info_ax,
    shelf_info_ay,
    shelf_info_az,
    shelf_info_ba,
    shelf_info_bb,
    shelf_info_bc,
    shelf_info_bd,
    shelf_info_be,
    shelf_info_bf,
    shelf_info_bg,
    shelf_info_bh,
    shelf_info_bi,
    setShelfInfoA,
    setShelfInfoB,
    setShelfInfoC,
    setShelfInfoD,
    setShelfInfoE,
    setShelfInfoF,
    setShelfInfoG,
    setShelfInfoH,
    setShelfInfoI,
    setShelfInfoJ,
    setShelfInfoK,
    setShelfInfoAA,
    setShelfInfoAB,
    setShelfInfoAC,
    setShelfInfoAD,
    setShelfInfoAE,
    setShelfInfoAF,
    setShelfInfoAG,
    setShelfInfoAH,
    setShelfInfoAI,
    setShelfInfoAJ,
    setShelfInfoAK,
    setShelfInfoAL,
    setShelfInfoAM,
    setShelfInfoAN,
    setShelfInfoAO,
    setShelfInfoAP,
    setShelfInfoAQ,
    setShelfInfoAR,
    setShelfInfoAS,
    setShelfInfoAT,
    setShelfInfoAU,
    setShelfInfoAV,
    setShelfInfoAW,
    setShelfInfoAX,
    setShelfInfoAY,
    setShelfInfoAZ,
    setShelfInfoBA,
    setShelfInfoBB,
    setShelfInfoBC,
    setShelfInfoBD,
    setShelfInfoBE,
    setShelfInfoBF,
    setShelfInfoBG,
    setShelfInfoBH,
    setShelfInfoBI,
    is_loading,
    status_code
  );

  // エラーナビゲーション制御
  const [has_valid_error, setHasValidError] = useState(false);

  useEffect(() => {
    setHasValidError(hasErrorMessage(contents));
  }, [contents]);

  const url_params = new URLSearchParams(document.location.search.substring(1));
  const item_id = url_params.get('item_id');
  return (
    <Router>
      {/* TODO sakuma 固定値はすべてこちらのContextを見るように修正する */}
      <FixedValuesContext.Provider
        value={{
          has_loan_approval: has_loan_approval,
          has_review_approval_status: review_approval_status,
        }}
      >
        <ScrollTop setChildShelfs={setChildShelfs} />
        <Switch>
          {/* KWANKGM04330_近代化資金案件詳細（マイページ） */}
          <Route
            exact
            path="/reception/:reception_cd/:reception_id/(2300|2310|2330|2400|2500|2610|2900|2910|3100|3400|4100)"
          >
            <ModernisationFundingCaseDetails
              step_navigation={step_navigation}
              reception_id={reception_id}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              status_code={status_code}
              is_staff={is_staff}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              agreement_info={agreement_info}
              sign_info={sign_info}
              review_approval_status_name={review_approval_status_name}
              review_message={review_message}
              is_guarantor={guarantor_info.is_guarantor}
              mp_flg={mp_flg}
              ma_flg={ma_flg}
              handleDecline={() => requestModule(KWANKGM04330A01)} //『辞退する』のモジュール
              handleExecution={() => requestModule(KWANKGM04330A02)} //『申込内容を変更する』のモジュール
              is_signer={is_signer}
            />
          </Route>
          {/* 辞退時：KWANKGM04040_借入申込完了 */}
          {/* NOTE 借入申込確認画面(2400,2500,2600,2700)で辞退した時の辞退完了画面を兼ねる */}
          <Route
            exact
            path="/reception/:reception_cd/:reception_id/(2300|2310|2330|2400|2500|2610|2900|2910|3100|3400)/declined"
          >
            <DeclineLoanApplication
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              is_loading={is_loading}
            />
          </Route>
          {/* KDANKGM05050_近代化資金契約書内容確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(3500|3600|3700|3800|3900)">
            <ModernisationFundingContractContentConfirm
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              reception_id={reception_id}
              status_code={status_code}
              sign_info={sign_info}
              guarantor_info={guarantor_info}
              display_status={display_status}
              is_signed={is_signed}
              mp_flg={mp_flg}
              handleDecline={() => requestModule(KDANKGM05010A01)} // 辞退する
              handleExecution={() => requestModule(KDANKGM05010A02)} // 契約手続きに進む
              is_loading={is_loading}
              is_checked_contract_document={is_checked_contract_document}
              info_notice={info_notice_contract_confirm}
              is_active_decline_btn={is_active_decline_btn}
              is_signer={is_signer}
            />
          </Route>
          {/* KWANKGM04320_近代化資金借入申込結果確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/(3000|93050)">
            <ModernisationFundingConfirmationResults
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true}
              parent_shelfs={parent_shelfs}
              child_shelfs={child_shelfs}
              contents={contents}
              reception_id={reception_id}
              status_code={status_code}
              guarantors_num={guarantors_num}
              is_loading={is_loading}
              display_status={display_status}
              show_error_nav={has_valid_error || show_error_nav}
              guarantor_info={guarantor_info}
              review_approval_status={review_approval_status}
              review_approval_status_name={review_approval_status_name}
              review_message={review_message}
              mp_flg={mp_flg}
              moveNextStep={() => moveStepNav(2)}
              setParentShelfs={setParentShelfs}
              setChildShelfs={setChildShelfs}
              setContents={setContents}
              callApi={requestModule}
            />
          </Route>
          {/* KWANKGM04080_契約申込確認 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000/confirm">
            <ContractApplicationConfirmation
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              display_reception_cd={display_reception_cd}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              looks_inactive={true} // 入力可否
              reception_id={reception_id}
              movePrevStep={() => moveStepNav(1)}
              moveNextStep={() => moveStepNav(3)}
              is_loading={is_loading}
              display_status={display_status}
              status_code={status_code}
              contractExecution={() => requestModule(KWANKGM04080A01)}
              refusalExecution={() => requestModule(KWANKGM04080A02)}
              contract_info={contract_info}
            />
          </Route>
          {/* 実行時：KWANKGM04090_契約申込完了 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000/finish">
            <ContractApplicationFinish
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              is_loading={is_loading}
            />
          </Route>
          {/* 辞退時：KWANKGM04090_契約申込完了 */}
          <Route exact path="/reception/:reception_cd/:reception_id/3000/declined">
            <ContractApplicationDeclined
              step_navigation={step_navigation}
              reception_cd={reception_cd}
              label={label}
              status_name={status_name}
              guide_text={
                guide_text !== null && guide_text[step_navigation.current]
                  ? guide_text[step_navigation.current]
                  : ''
              }
              is_staff={is_staff}
              is_loading={is_loading}
            />
          </Route>
        </Switch>
      </FixedValuesContext.Provider>
    </Router>
  );
};

if (document.getElementById('template-modernization-funds-main')) {
  ReactDOM.render(
    <AppModernizationFundsMain />,
    document.getElementById('template-modernization-funds-main')
  );
}
